import { ChangeDetectorRef, inject, type OnDestroy, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { type Subscription } from 'rxjs';

@Pipe({
  name: 'overrideDisplayDescription',
  pure: false
})
export class OverrideDisplayDescriptionPipe implements PipeTransform, OnDestroy {
  private lang: string;
  private subscription: Subscription;

  private translate = inject(TranslateService);

  constructor(private cdr: ChangeDetectorRef) {
    this.lang = this.translate.currentLang;
    this.subscription = this.translate.onLangChange.subscribe(e => {
      this.lang = e.lang;
      this.cdr.markForCheck();
    });
  }

  transform(item: { displayDescriptions?: Record<string, string>; description?: string } | null | undefined): string {
    if (!item) {
      return '';
    }
    const displayDescription = item.displayDescriptions?.[this.lang]?.trim();
    const fallback = typeof item.description === 'string' && item.description.trim() !== '' ? this.translate.instant(item.description) : '';

    return displayDescription || fallback;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
